<template>
  <div class="consent-withdrawals pa-10">
    <v-card class="mb-4">
      <v-card-text class="d-flex align-center flex-wrap" style="gap: 12px">
        <div class="flex-grow-1">
          <div class="text-h6">{{ $t('onboarding.consent-withdrawal.title') }}</div>
          <div class="text-caption text--secondary">{{ $t('onboarding.consent-withdrawal.explained') }}</div>
        </div>
        <v-btn-toggle v-model="decided" mandatory dense color="primary" @change="load">
          <v-btn small :value="false">{{ $t('onboarding.consent-withdrawal.to-decide') }}</v-btn>
          <v-btn small :value="true">{{ $t('onboarding.consent-withdrawal.decided') }}</v-btn>
        </v-btn-toggle>
      </v-card-text>
    </v-card>

    <v-alert v-if="error" type="error" dense outlined class="mb-4">{{ error }}</v-alert>
    <v-skeleton-loader v-if="loading" type="card" />
    <v-alert v-else-if="!rows.length" type="info" dense text>{{ $t(decided ? 'onboarding.consent-withdrawal.none-decided' : 'onboarding.consent-withdrawal.none') }}</v-alert>

    <v-card v-for="row in rows" :key="row.id" class="mb-3">
      <v-card-text>
        <consent-decision-panel :row="row" @decided="load" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ConsentWithdrawalRepository from '@repository/ConsentWithdrawalRepository'
import ConsentDecisionPanel from './Consent/ConsentDecisionPanel.vue'

/**
 * Les demandes de retrait de consentement (décision métier : jamais de retrait direct par la personne). ZEborne
 * accepte — l'accord est retiré, les équipements qui en dépendent se désactivent — ou refuse avec un motif que la
 * personne lit dans son espace client. Celles à trancher sont aussi une file des commandes en attente.
 */
export default {
  name: 'ConsentWithdrawals',

  components: { ConsentDecisionPanel },

  data() {
    return {
      rows: [],
      decided: false,
      loading: false,
      error: null,
    }
  },

  created() {
    this.load()
  },

  methods: {
    async load() {
      this.loading = true
      this.error = null
      try {
        this.rows = await ConsentWithdrawalRepository.list(this.decided)
      } catch (e) {
        const data = e?.response?.data
        this.error = data?.messageKey && this.$te(data.messageKey) ? this.$t(data.messageKey, data.parameters || {}) : (data?.message || this.$t('error-occurred'))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
